









































import { Component, Prop, Vue } from 'vue-property-decorator';
import NumKeyPad from '@/components/NumKeyPad.vue';

const RANDOM_PEPPER: string = "4c6079cfdc6233636d7d9bc715ca9399";
const PIN_HASH: string = "e11b581d52ea745ef9eb06e7a33b6d0feb240798de17255fcf35d8ed26a80e10";

@Component({
  components: {
    NumKeyPad,
  },
})
export default class PinPadComponent extends Vue {

  pinCode: string = '';
  isPinError: boolean = false;

  // lifecycle hooks
  mounted() {
    (this.$refs.pin as HTMLInputElement).focus();
  }

  // computed

  // methods
  onDigit(digit: number) {
    if ( this.pinCode.length < 8 ) {
      this.pinCode = this.pinCode + digit;
      this.clearError();
    }
  }
  async onEnter() {
    //console.log("on return key");
    const hashHex = await this.digestMessage(this.pinCode + RANDOM_PEPPER);
    if ( hashHex === PIN_HASH ) {
      //console.log("correct PIN!");
      this.clearError();
      this.$emit('on-correct-pin');
    }
    else {
      //console.log("wrong PIN");
      this.setError();
      this.$emit('on-wrong-pin');
    }
  }
  onBackspace() {
    if ( this.pinCode.length > 0 ) {
      this.pinCode = this.pinCode.substr(0, this.pinCode.length - 1);
      this.clearError();
    }
  }

  setError() {
    this.isPinError = true;
    const self = this;
    window.setTimeout(() => {
      self.pinCode = '';
    }, 350);
  }

  clearError() {
    this.isPinError = false;
  }

  async digestMessage(message: string): Promise<string> {
    const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashHex;
  }

}
